import React from 'react';
import { ArrowUpRight, FileText, Github, Linkedin } from 'lucide-react';
import { profile } from '../data/profile';
import { Eyebrow } from './ui';

const Contact: React.FC = () => (
  <section id="contact" className="scroll-mt-20 border-t border-ink-700 py-24 sm:py-32">
    <div className="reveal">
      <Eyebrow index="05">Contact</Eyebrow>
      <h2 className="mt-5 max-w-4xl font-serif text-[clamp(2.75rem,7vw,5.5rem)] leading-[1] tracking-tight text-fg">
        Let’s build something <em className="text-accent">reliable</em>.
      </h2>
      <p className="mt-6 max-w-xl text-lg text-fg-muted">
        Always happy to talk backend systems, infrastructure, or interesting engineering problems.
      </p>

      <a
        href={`mailto:${profile.email}`}
        className="group mt-10 inline-flex items-center gap-2 break-all border-b border-ink-600 pb-1 text-xl text-fg transition-colors hover:border-accent hover:text-accent sm:text-3xl"
      >
        {profile.email}
        <ArrowUpRight className="shrink-0 transition group-hover:-translate-y-0.5 group-hover:translate-x-0.5" size={24} />
      </a>

      <div className="mt-10 flex flex-wrap gap-3">
        {[
          { href: profile.github, label: 'GitHub', icon: <Github size={15} /> },
          { href: profile.linkedin, label: 'LinkedIn', icon: <Linkedin size={15} /> },
          { href: profile.resume, label: 'Résumé', icon: <FileText size={15} /> },
        ].map((link) => (
          <a
            key={link.label}
            href={link.href}
            target="_blank"
            rel="noopener noreferrer"
            className="inline-flex items-center gap-2 rounded-full border border-ink-600 px-4 py-2 text-sm text-fg-muted transition-colors hover:border-accent/60 hover:text-fg"
          >
            {link.icon}
            {link.label}
          </a>
        ))}
      </div>
    </div>
  </section>
);

export default Contact;
